module.exports = __webpack_public_path__ + "VIPV23.png?98cd5a627087d8fadf3e6709cd792512";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV23.png
// module id = 118
// module chunks = 0